import css from 'styled-jsx/css';

export default css`
  .Charac {
    :global(.Charac_icon) {
      margin: 0 auto;
    }
    :global(.Charac_label) {
      margin: 1rem 0 0 0;
    }
    :global(.Charac_description) {
      margin: 1rem 0 0 0;
    }
  }
`;
